module.exports = __webpack_public_path__ + "static/media/Apercu-LightItalic.c74d898d.woff";